import React, { useMemo } from 'react';
import { useLaborCostDashboardStore } from 'pages/ReportsPage/components/AnalyticsDashboards/LaborCostDashboard/store/laborCostDashboard.store';
import {
  useChartColors,
  createHeatMapColorScale,
} from 'pages/ReportsPage/components/AnalyticsDashboards/chartColors';
import { HeatMapGrid } from 'pages/ReportsPage/components/AnalyticsDashboards/FulfillmentDashboard/HeatMapGrid';
import { EmptyStateContainer } from 'pages/ReportsPage/components/AnalyticsDashboards/LaborCostDashboard/LaborCostDashboard.styled';
import {
  TIMEFRAMES,
  DAYS_OF_WEEK,
} from 'pages/ReportsPage/components/AnalyticsDashboards/LaborCostDashboard/LaborCostDashboard.constants';

function buildHeatMapMatrix(
  cells: { timeframe: string; dayOfWeek: string; avgHours: number | null }[],
  rowLabels: readonly string[],
  colLabels: readonly string[],
): number[][] {
  const lookup = new Map(cells.map((c) => [`${c.timeframe}-${c.dayOfWeek}`, c.avgHours]));
  return rowLabels.map((row) => colLabels.map((col) => lookup.get(`${row}-${col}`) ?? 0));
}

export const ResolutionSpeedChart: React.FC = () => {
  const data = useLaborCostDashboardStore((s) => s.resolutionSpeedCells);
  const palette = useChartColors();

  const matrix = useMemo(
    () => (data ? buildHeatMapMatrix(data, TIMEFRAMES, DAYS_OF_WEEK) : []),
    [data],
  );

  const colorScale = useMemo(
    () => createHeatMapColorScale(palette.chartColors[3] || '#1C0F51'),
    [palette.chartColors],
  );

  if (!data) {
    return <EmptyStateContainer>No data available</EmptyStateContainer>;
  }

  return (
    <HeatMapGrid
      rowLabels={[...TIMEFRAMES]}
      columnLabels={[...DAYS_OF_WEEK]}
      data={matrix}
      colorScale={colorScale}
      valueFormatter={(v) => `${v.toFixed(2)}h`}
      cellFormatter={(v) => v.toFixed(2)}
      ariaLabel="Average speed to resolve call outs heat map"
    />
  );
};
